<!-- Ported from the Polaris kit: src/components/ui/table/Table.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port. -->
<script setup>
import { cn } from '../../lib/utils';

const props = defineProps({
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});
</script>

<template>
  <div data-slot="table-container" class="relative w-full overflow-auto">
    <table
      data-slot="table"
      :class="cn('w-full caption-bottom type-polaris-body', props.class)"
    >
      <slot />
    </table>
  </div>
</template>
